import { ElementType } from 'react';
import { Container as MUIContainer, ContainerProps } from '@mui/material';

interface IContainerProps extends ContainerProps {
  component?: ElementType;
}

const Container = (props: IContainerProps) => {
  const { children, ...restProps } = props;
  return <MUIContainer {...restProps}>{children}</MUIContainer>;
};

export default Container;
